// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"bb4cde25","787":"53b9d020","839":"81219ba7"}[chunkId] + ".chunk.js";
};